/**
 * @type {Object}
 * @property {array}  data  Item data
 */
const initialState = {
    deliveryConditions: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerDeliveryCondition = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case 'FETCH_DELIVERY_CONDITIONS':
            var { data } = action;
            newState.deliveryConditions = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerDeliveryCondition;